import React, { useState } from 'react';
import { Button, Modal, Input, List, Avatar, Spin } from 'antd';
import { SendOutlined, RobotOutlined, UserOutlined } from '@ant-design/icons';
import { sendChatMessage } from '../../utils/api';
import { notifyApiError } from '../../utils/notification';

const ChatBot = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  const handleSendMessage = async () => {
    if (!inputMessage.trim() || isLoading) return;

    const userMessage = { id: Date.now(), text: inputMessage, isBot: false };
    setMessages(prev => [...prev, userMessage]);
    setInputMessage('');
    setIsLoading(true);

    try {
      const response = await sendChatMessage(inputMessage, sessionId);
      if (response.sessionId) setSessionId(response.sessionId);

      const botMessage = {
        id: Date.now() + 1,
        text: response.response,
        isBot: true,
        citation: response.citation,
      };
      setMessages(prev => [...prev, botMessage]);
    } catch (error) {
      notifyApiError('Failed to send message');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '270px',
          zIndex: 1000,
          width: '60px',
          height: '80px',
          cursor: 'pointer',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => setIsVisible(true)}>
        {/* Body - slides down on hover */}
        <img
          src="/sam-bot-body.png"
          alt="AI Body"
          style={{
            position: 'absolute',
            bottom: isHovered ? '0px' : '-20px',
            left: '50%',
            transform: 'translateX(-50%)',
            height: isHovered ? '100px' : '50px',
            transition: 'all 0.3s ease',
            opacity: isHovered ? 1 : 0,
          }}
        />

        {/* Head - slides up on hover */}
        <img
          src="/sam-bot-head.png"
          alt="AI Head"
          style={{
            position: 'absolute',
            bottom: isHovered ? '70px' : '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            height: isHovered ? '100px' : '50px',
            transition: 'all 0.3s ease',
            opacity: isHovered ? 1 : 0.4,
          }}
        />
      </div>

      <Modal
        title="S.A.M B0T"
        visible={isVisible}
        onCancel={() => setIsVisible(false)}
        footer={null}
        width={400}
        bodyStyle={{ padding: 0, height: '500px', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, padding: '16px', overflowY: 'auto' }}>
          <div
            style={{
              textAlign: 'center',
              padding: '16px',
              marginBottom: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              color: '#666',
            }}>
            👋 Hi! I'm S.A.M. Bot, aka System Assistance Mentor. I have a multitude of capabilities to assist you in
            navigating the WRKFLOZ software platform. What can I help you with today?
          </div>

          <List
            dataSource={messages}
            renderItem={message => (
              <List.Item style={{ border: 'none', padding: '8px 0' }}>
                <List.Item.Meta
                  avatar={<Avatar icon={message.isBot ? <RobotOutlined /> : <UserOutlined />} />}
                  description={
                    <div
                      style={{
                        backgroundColor: message.isBot ? '#f0f0f0' : '#e6f7ff',
                        padding: '8px 12px',
                        borderRadius: '12px',
                      }}>
                      {message.text}
                      {message.citation && (
                        <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                          Source: {message.citation}
                        </div>
                      )}
                    </div>
                  }
                />
              </List.Item>
            )}
          />
          {isLoading && (
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <Spin /> Thinking...
            </div>
          )}
        </div>

        <div style={{ padding: '16px', borderTop: '1px solid #f0f0f0' }}>
          <Input.Group compact>
            <Input
              value={inputMessage}
              onChange={e => setInputMessage(e.target.value)}
              onPressEnter={handleSendMessage}
              placeholder="Ask about your documents..."
              style={{ width: 'calc(100% - 40px)' }}
            />
            <Button type="primary" onClick={handleSendMessage} loading={isLoading} style={{ width: '40px' }}>
              <SendOutlined />
            </Button>
          </Input.Group>
        </div>
      </Modal>
    </>
  );
};

export default ChatBot;
